export const LEFT = 'left'
export const RIGHT = 'right'
export const CENTER = 'center'
export const JUSTIFY = 'justify'
export const textAlignmentToPosition = {
    [LEFT]: 'start',
    [RIGHT]: 'end',
    [CENTER]: 'center'
}
